//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import FactorDrawer from "./modules/FactorDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: 'FactorList',
  mixins: [JeecgListMixin],
  components: {
    FactorDrawer: FactorDrawer
  },
  data: function data() {
    return {
      pagePath: '/site/factor',
      pageTitle: '环境监测因子',
      unitOptions: [],
      // 表头
      columns: [{
        title: '编号',
        align: 'center',
        dataIndex: 'code',
        colName: 'code',
        sorter: true
      }, {
        title: '名称',
        align: 'center',
        dataIndex: 'title',
        colName: 'title',
        sorter: true
      }, {
        title: '原编码',
        align: 'center',
        dataIndex: 'past',
        colName: 'past',
        sorter: true
      }, {
        title: '别名',
        align: 'center',
        dataIndex: 'alias',
        colName: 'alias',
        sorter: true
      }, {
        title: '类型',
        align: 'center',
        dataIndex: 'categoryName',
        colName: 'category',
        sorter: true
      }, {
        title: '系统编码',
        align: 'center',
        dataIndex: 'st_dictText',
        colName: 'st',
        sorter: true
      }, {
        title: '限制类型',
        align: 'center',
        dataIndex: 'restriction_dictText',
        colName: 'restriction',
        sorter: true
      }, {
        title: '最小值',
        align: 'center',
        dataIndex: 'lower',
        colName: 'lower',
        sorter: true
      }, {
        title: '最大值',
        align: 'center',
        dataIndex: 'upper',
        colName: 'upper',
        sorter: true
      }, {
        title: '每日监测次数',
        align: 'center',
        dataIndex: 'monitorNum',
        colName: 'monito_num',
        sorter: true
      }, {
        title: '整数位',
        align: 'center',
        dataIndex: 'intbits',
        colName: 'intbits',
        sorter: true
      }, {
        title: '小数位',
        align: 'center',
        dataIndex: 'decimals',
        colName: 'decimals',
        sorter: true
      }, {
        title: '数据单位',
        align: 'center',
        dataIndex: 'unitName',
        colName: 'unit_name',
        sorter: true
      }, {
        title: '统计方法',
        align: 'center',
        dataIndex: 'stat_dictText',
        colName: 'stat',
        sorter: true
      }, {
        title: '是否预警',
        align: 'center',
        dataIndex: 'warning_dictText',
        colName: 'warning',
        sorter: true
      }, {
        title: '数据可见性',
        align: 'center',
        dataIndex: 'visible_dictText',
        colName: 'visible',
        sorter: true
      }, {
        title: '状态',
        align: 'center',
        dataIndex: 'status_dictText',
        colName: 'status',
        sorter: true
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      factorTypeCode: 'factor_type_1'
    };
  },
  created: function created() {
    this.queryUnitList();
  },
  computed: {},
  methods: {
    queryUnitList: function queryUnitList() {
      var _this = this;

      var params = {
        pageNo: 1,
        pageSize: 10000,
        status: '1'
      };
      getAction('/site/factor/unit', params).then(function (res) {
        if (res.success) {
          _this.unitOptions = res.result.records;
        } else {
          console.log(res.message);
        }
      });
    },
    modalFormOk: function modalFormOk() {
      // this.searchReset()
      // 新增/修改 成功时，重载列表
      this.loadData();
    },
    handleChangeSt: function handleChangeSt(value) {
      this.factorTypeCode = 'factor_type_' + value;
      this.queryParam.st = value;
    },
    handleChangeCode: function handleChangeCode(value) {
      this.queryParam.category = value;
    }
  }
};